import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Child, useApiContext, useWindowSize } from 'react-easyrocket';
import { generatePath, useNavigate } from 'react-router';
import { CONTENT_URL } from 'src/api';
import { Button } from 'src/components/Buttons/Button';
import { CmsContent } from 'src/components/CmsContent';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { LANG_PARAM } from 'src/router/hooks';

export interface MainPageBannersProps {
  slide: Child;
}

const MainPageSliderCard: FC<MainPageBannersProps> = ({ slide }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();
  const { isMobileLayout } = useWindowSize();
  const { isAuthenticated } = useApiContext();
  const navigate = useNavigate();
  const { startRegistration } = useAuthFlow();

  return (
    <div
      className="w-full aspect-[360/267] md:aspect-[1200/487] flex items-center justify-center mb-[10px]"
      style={{
        background: isMobileLayout
          ? `url('${CONTENT_URL + slide.imageMobile}')`
          : `url('${CONTENT_URL + slide.image}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}>
      <div className="flex flex-col font-bold items-center pt-[10px] gap-1">
        <CmsContent
          className="[&>p>strong]:text-mp_banner_title [&>p>strong]:text-[32px] [&>p>strong]:lg:text-[60px] text-center [&>p>strong]:md:text-[48px] [&>p>strong]:leading-[120%] leading-[120%] [&>p]:flex [&>p]:flex-col [&>p>span]:text-[20px] [&>p>span]:md:text-[26px] [&>p>span]:lg:text-[32px] [&>p>span]:text-mp_banner_text"
          content={slide.content}
        />
        {!isAuthenticated ? (
          <Button
            mode="button-primary"
            className="max-h-[30px] md:max-h-[40px] md:mt-[40px] mt-5"
            onClick={() => startRegistration()}>
            {t('general.signUp')}
          </Button>
        ) : (
          <Button
            mode="button-primary"
            className="max-h-[30px] md:max-h-[40px] md:mt-[40px] mt-5"
            onClick={() => {
              navigate(
                generatePath(LANG_PARAM + slide.title, { lang: language.replace('en', '') })
              );
            }}>
            {t('general.getOffer')}
          </Button>
        )}
      </div>
    </div>
  );
};

// eslint-disable-next-line no-restricted-exports
export default MainPageSliderCard;
